import React, { useEffect } from "react";
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Typography,
	Button,
	LinearProgress,
	Box,
} from "@mui/material";
import { Warning } from "@mui/icons-material";

const InactivityWarning = ({
	open,
	secondsRemaining,
	totalSeconds,
	onStayLoggedIn,
	onLogout,
}) => {
	// Auto logout when timer reaches 0
	useEffect(() => {
		if (secondsRemaining <= 0 && open) {
			onLogout();
		}
	}, [secondsRemaining, open, onLogout]);

	const progress = (secondsRemaining / totalSeconds) * 100;

	// Format time as MM:SS
	const formatTime = (seconds) => {
		const mins = Math.floor(seconds / 60);
		const secs = seconds % 60;
		return `${mins}:${secs.toString().padStart(2, "0")}`;
	};

	return (
		<Dialog
			open={open}
			onClose={onStayLoggedIn}
			maxWidth='sm'
			fullWidth
			PaperProps={{
				sx: {
					borderLeft: "6px solid #f59e0b",
				},
			}}
		>
			<DialogTitle>
				<Box display='flex' alignItems='center' gap={2}>
					<Warning sx={{ color: "#f59e0b" }} />
					<Typography variant='h6' fontWeight='bold'>
						Inactivity Warning
					</Typography>
				</Box>
			</DialogTitle>

			<DialogContent>
				<Typography variant='body1' gutterBottom>
					You have been inactive for a while. For security reasons, you will be
					logged out in:
				</Typography>

				<Box sx={{ textAlign: "center", my: 3 }}>
					<Typography variant='h3' color='warning.main' fontWeight='bold'>
						{formatTime(secondsRemaining)}
					</Typography>
					<Typography variant='caption' color='text.secondary'>
						minutes:seconds remaining
					</Typography>
				</Box>

				<LinearProgress
					variant='determinate'
					value={progress}
					color='warning'
					sx={{
						height: 8,
						borderRadius: 4,
						backgroundColor: "#fef3c7",
					}}
				/>
			</DialogContent>

			<DialogActions sx={{ px: 3, pb: 3 }}>
				<Button onClick={onLogout} variant='outlined' color='inherit'>
					Logout Now
				</Button>
				<Button
					onClick={onStayLoggedIn}
					variant='contained'
					sx={{
						backgroundColor: "#f59e0b",
						"&:hover": {
							backgroundColor: "#d97706",
						},
					}}
					autoFocus
				>
					Stay Logged In
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default InactivityWarning;
